import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;

  @media (max-width: 640px) {
    padding: 0;
    align-items: end;
  }
`;

const ModalContent = styled.div`
  position: relative;
  background: #333;
  padding: 20px;
  border-radius: 32px;
  max-width: 878px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 100vh;
  max-height: 526px;

  @media (max-width: 640px) {
    border-radius: 32px 32px 0 0;
    bottom: 0;
    max-height: 420px;
  }
`;

const ControlBar = styled.button`
  display: none;
  border-radius: 32px;
  width: 100%;
  max-width: 100px;
  height: 6px;
  background-color: var(--gray-03);
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;

  @media (max-width: 640px) {
    display: block;
  }
`;

const ExercisesIframe = styled.iframe`
  height: 100%;
  width: 100%;
`;

const CloseButton = styled.button`
  font-size: 50px;
  line-height: 1;
  position: absolute;
  padding: 20px;
  right: 0;
  top: 0;
`;

type Props = {
  guid: string;
  isOpen: boolean;
  onClose: () => void;
};

const MockExamModal: React.FC<Props> = ({ guid, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <ControlBar type="button" onClick={onClose} />
        <CloseButton type="button" onClick={onClose}>
          &times;
        </CloseButton>
        <ExercisesIframe
          className="exercises"
          title="exercises"
          src={`${location.protocol}//${location.host}/exercises/confirmation/${guid}`}
          role="application"
        />
      </ModalContent>
    </ModalOverlay>
  );
};

export default MockExamModal;
